import React from "react";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { useSelector } from "react-redux";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const Forecast = () => {
  const {
    forecast,
    currencySymbol,
    forecastTooltip = ""
  } = useSelector((state) => state.revenueBreakdown.allRevenues);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <SectionContainer
      title="Forecast"
      toolTip={forecastTooltip}
      isToolTipHtml
      toolTipId="revenueBreakdownForecast"
    >
      <MoneyDisplay
        value={forecast}
        color="#92bef4"
        currency={currencySymbol}
        size={44}
        disableAnimation={isUserQa}
        toolTip={forecastTooltip}
        toolTipId="revenueBreakdownForecast"
      />
    </SectionContainer>
  );
};

export default Forecast;
